<template>
  <div
    class="toggle-container"
    :class="isSession || isAccountSettings ? 'session-toggle-container' : ''"
  >
    <div :class="isColor ? 'flex-column' : 'flex-row-center'">
      <ComingSoon v-if="comingSoon" />
      <div>
        <settings-title type="h3" v-if="title"> {{ title }} </settings-title>
        <br />
        <settings-text type="tight"> {{ description }} </settings-text>
      </div>
      <ToggleButton
        v-if="!isSelect && !isColor"
        :isEnabled="isEnabled"
        :isSession="isSession"
        :isAccountSettings="isAccountSettings"
        @toggled="toggled"
      />
      <SessionColorPicker
        v-else-if="isColor"
        :colors="colors"
        @setColor="setColor"
      />
      <Select
        v-else
        :currentSelection="currentSelection"
        :options="selectOptions"
        @selected="updatePreference"
      />
    </div>
  </div>
</template>
<script>
import SessionColorPicker from "../../../RoomPages/Session/SessionComponents/SessionSettings/SessionColorPicker";
import SettingsText from "./SettingsText";
import SettingsTitle from "./SettingsTitle";
import ComingSoon from "./ComingSoon";
import ToggleButton from "./ToggleButton";
import Select from "./Select";

export default {
  name: "SettingArea",
  props: {
    isEnabled: Boolean,
    comingSoon: Boolean,
    title: String,
    description: String,
    selectOptions: Array,
    colors: Array,
    isRematch: Boolean,
    isAccountSettings: Boolean,
    isSession: Boolean,
    isSelect: Boolean,
    isColor: Boolean,
    currentSelection: {
      type: [String, Number],
    },
  },
  components: {
    ComingSoon,
    ToggleButton,
    SettingsTitle,
    SettingsText,
    Select,
    SessionColorPicker,
  },
  methods: {
    toggled() {
      if (this.isSession || this.isAccountSettings) {
        this.$emit("toggled", !this.isEnabled);
      } else {
        if (!this.comingSoon) {
          /* careful, the 'Don't Rematch Value' is in reverse (!isEnabled) in generalPreferences,
        this means if to just emit '!this.isEnabled' it would lead that value to be the opposite
        of what is desired */
          let value = !this.isEnabled;
          if (this.isRematch) {
            value = !value;
          }
          this.$emit("toggled", value);
        }
      }
    },
    updatePreference(newValue) {
      this.$emit("selected", newValue);
    },
    setColor(newValue) {
      this.$emit("setColor", newValue);
    },
  },
};
</script>

<style scoped>
/* flex-row-center, flex-column-center */
@import "../utilities.css";
.toggle-container {
  justify-content: space-between;
  max-width: 500px;
  margin: 20px auto 30px 40px;
  box-sizing: border-box;
  position: relative;
  /* padding-right: 50px; */
}
.session-toggle-container {
  max-width: 580px;
  margin: 20px auto 38px 35px;
}
</style>